import FormularioGastos from "components/gastos/FormularioGastos";
import Navbar from "components/generales/Navbar";
import React from "react";
import "components/generales/Styles.css";
import "components/gastos/StylesGastos.css";

const RegistrarGastos = ({ gasto }) => {
  return (
    <>
      <Navbar />
      <section>
        <div className="imagenContenedor imagenGastos"></div>
        <div className="contenidoContenedor">
          <div className="formularioContenedor">
            <h2>{gasto?.nombre ? "Editar Gasto" : "Registrar Gasto"}</h2>
            <FormularioGastos gasto={gasto} />
          </div>
        </div>
      </section>
    </>
  );
};

export default RegistrarGastos;
